"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakeholderProfileMapSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var StakeholderProfileMapSection = function (_a) {
    var yAxis = _a.yAxis, xAxis = _a.xAxis, getCellContent = _a.getCellContent;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "spm__section" }, { children: yAxis.map(function (y) {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "spm__section-row" }, { children: xAxis.map(function (x) {
                    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "spm__cell" }, { children: getCellContent(x, y) }), x + y));
                }) }), "y-".concat(y)));
        }) })));
};
exports.StakeholderProfileMapSection = StakeholderProfileMapSection;
